export const routes = (parentName) => {
  return [
    {
      path: "transactions",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Transactions`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Transactions-New`,
          component: () => import("./Upsert.vue"),
        },
        //  {
        //   path: ":id",
        //   name: parentName + "-" + "Referrals-View",
        //   component: () => import("./View.vue"),
        //   },
        {
          path: ":id/edit",
          name: parentName + "-" + "Transactions-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
